import { render } from "./TextoEdicao.vue?vue&type=template&id=0028ecf0&scoped=true&ts=true"
import script from "./TextoEdicao.vue?vue&type=script&lang=ts"
export * from "./TextoEdicao.vue?vue&type=script&lang=ts"

import "./TextoEdicao.vue?vue&type=style&index=0&id=0028ecf0&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0028ecf0"]])

export default __exports__